<template>
  <custom-overlay class="bg-white">
    <div class="text-center h-full bg-white" style="padding-top: 20vh">
      <img src="/assets/img/gray-logo.png" alt="" width="128" />
      <div class="my-6">问卷已更新，点击 <span class="text-theme cursor-pointer" @click="onRestart">重新开始</span> 重新答题</div>
      <div class="py-6">
        <el-button type="primary" @click="onRestart">重新开始</el-button>
      </div>
    </div>
  </custom-overlay>
</template>

<script>
import CustomOverlay from '@/components/overlay/CustomOverlay'

export default {
  name: 'OverlayRestart',
  components: { CustomOverlay },
  props: {},
  methods: {
    onRestart() {
      this.$emit('restart')
    }
  }
}
</script>

<style scoped></style>
